/* asif-marquee-stop
   ----------------------------------------------------------------------
   Ein Halteschalter fuer die Ankuendigungsleiste.

   WCAG 2.2 SC 2.2.2, Stufe A: Bewegung, die automatisch startet, laenger
   als fuenf Sekunden dauert und neben anderem Inhalt steht, braucht einen
   Mechanismus zum Anhalten. prefers-reduced-motion wird respektiert, ist
   aber eine Systemeinstellung - kein Mechanismus im Sinne der Regel.

   Der Schalter merkt sich die Entscheidung fuer die Sitzung. Wer angehalten
   hat, will nicht auf jeder Unterseite wieder anhalten.
   ---------------------------------------------------------------------- */

(function () {
  var KEY = 'asif-marquee-paused';

  function findBar() {
    var track = document.querySelector(
      '.as-if-banner__crawl-wrapper, .as-if-banner__track, [class*="crawl-wrapper"], ' +
      '.announcement-bar [class*="marquee"], [class*="announcement"] [class*="marquee"], [class*="ticker"]'
    );
    if (!track) return null;
    var host = track.closest('.announcement-bar, [class*="announcement"], .as-if-banner, section, header') || track.parentElement;
    return host || null;
  }

  function moving(node) {
    if (!node) return false;
    var found = false;
    var all = [node].concat(Array.prototype.slice.call(node.querySelectorAll('*')));
    for (var i = 0; i < all.length && !found; i++) {
      var s = getComputedStyle(all[i]);
      if (s.animationName && s.animationName !== 'none' &&
        (s.animationIterationCount === 'infinite' || parseFloat(s.animationDuration) > 5)) found = true;
    }
    return found;
  }

  function boot() {
    var host = findBar();
    if (!host || !moving(host)) return;
    if (host.querySelector('.asif-marquee-stop')) return;

    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var paused = false;
    try { paused = sessionStorage.getItem(KEY) === '1'; } catch (e) { /* ohne Speicher geht es auch */ }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'asif-marquee-stop';
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');

    function apply() {
      document.documentElement.toggleAttribute('data-marquee-paused', paused);
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? 'Laufschrift wieder starten' : 'Laufschrift anhalten');
      btn.textContent = paused ? '▶' : '❙❙';
      try { sessionStorage.setItem(KEY, paused ? '1' : '0'); } catch (e) { /* egal */ }
    }

    btn.addEventListener('click', function () { paused = !paused; apply(); });
    apply();
    host.appendChild(btn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
